/**
 * Project-specific color tokens for cases sputnik-ui's theme.palette doesn't cover
 * (e.g. semantic status/priority pills). Check theme.palette first — only pull
 * from here, or add to it, when nothing there fits.
 */
const palette = {
  danger: {
    color: '#F64D4D',
    background: '#FFEDEE',
  },
  warning: {
    color: '#D68B00',
    background: '#FFF6E5',
  },
  success: {
    color: '#168B4B',
    background: '#EDF9F2',
  },
  info: {
    color: '#3B6DF0',
    background: '#F0F4FF',
  },
  neutral: {
    color: '#6D6D6D',
    background: '#F2F2F5',
  },
  accent: {
    color: '#0EA7FF',
    background: '#EAF6FF',
  },
}

export default palette
